import { Box, SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ReactNode } from "react";

export const fadedPrimaryBg = (theme: Theme, opacity = 0.12) =>
  alpha(
    theme.palette.primary.vibrant || theme.palette.primary.main,
    opacity,
  );

interface IWooCommerceOnboardingPlatformLogoBoxProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

function WooCommerceOnboardingPlatformLogoBox({
  children,
  sx,
}: IWooCommerceOnboardingPlatformLogoBoxProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          width: 40,
          height: 40,
          flexShrink: 0,
          borderRadius: 1,
          bgcolor: fadedPrimaryBg(theme),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  );
}

export default WooCommerceOnboardingPlatformLogoBox;
